import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import DoubleTranslatedCustomRichText from '@/components/CustomRichText/DoubleTranslatedCustomRichText';import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import InfoMsg from '@/components/UI/InfoMsg/InfoMsg';
import Spinner from '@/components/UI/Spinner/Spinner';
import * as Constants from '@/helpers/constants';
import { getEditorId, removeParagraphTags, tabLowerCase } from '@/helpers/utils';
import useToastContext from '@/hooks/useToastContext';
import { setHelpSummaryPlantFeedback } from '@/redux/Help/help.action';
import { getHelpSummaryPlantFeedback } from '@/redux/Help/help.reducer';
import administrationServices from '@/services/administrationServices';
import { ReduxHelp } from '@/types';
import styles from '../HelpText.module.scss';

type SummaryPlantFeedbackHelpTextProps = {
  helpSummaryPlantFeedback: ReduxHelp;
  setSummaryPlantFeedback: (data: ReduxHelp) => void;
};

const SummaryPlantFeedbackHelpText: React.FC<SummaryPlantFeedbackHelpTextProps> = (props) => {
  const { t } = useTranslation();
  const tab = tabLowerCase(window.location.pathname.split('/')[4]);
  const [originalValues, setOriginalValues] = useState({});
  const { helpSummaryPlantFeedback, setSummaryPlantFeedback } = props;
  const isLoading = helpSummaryPlantFeedback && !helpSummaryPlantFeedback.SUMMARY_PLANT_FEEDBACK_TAB;
  const { addToast } = useToastContext();
  const SUMMARY_PLANT_FEEDBACK_TAB = 'SUMMARY_PLANT_FEEDBACK_TAB';
  const SUMMARY_PLANT_FEEDBACK_PLANT_FEEDBACK = 'SUMMARY_PLANT_FEEDBACK_PLANT_FEEDBACK';

  const ID_GENERAL_SUMMARY_PLANT_FEEDBACK = 'general-summaryPlantFeedback';
  const ID_SUMMARY_PLANT_FEEDBACK_PLANT_FEEDBACK = 'summaryPlantFeedback-plantFeedback';

  useEffect(() => {
    administrationServices.getHelp(tab)
      .then((data) => {
        const values = helpSummaryPlantFeedback && helpSummaryPlantFeedback?.modified ? helpSummaryPlantFeedback : data;
        setSummaryPlantFeedback(values);
        setOriginalValues(values);
      })
      .catch((error) => addToast(error.message, 'ERROR'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleWysiwygChange = (lang: 'EN' | 'DE', label: string, data: string) => {
    const propValues = { ...helpSummaryPlantFeedback[label] };
    const isModified = removeParagraphTags(data) !== removeParagraphTags(originalValues[label][lang]);
    const newState = {
      ...helpSummaryPlantFeedback,
      [label]: {
        ...propValues,
        [lang]: data,
      },
      modified: isModified,
    };

    if (isModified) {
      setSummaryPlantFeedback(newState as unknown as ReduxHelp);
      setOriginalValues(newState);
    }
  };

  return (
    <>
      {isLoading && <Spinner isVisible isMask />}
      {!isLoading && (
        <>
          <InfoMsg msg={t('administration.helpText.info')} />
          <AccordionPanel title={t('administration.helpText.generalText')}>
            <DoubleTranslatedCustomRichText
              id={ID_GENERAL_SUMMARY_PLANT_FEEDBACK}
              title={t('helptext')}
              initialValue={helpSummaryPlantFeedback?.SUMMARY_PLANT_FEEDBACK_TAB}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang as 'EN' | 'DE', SUMMARY_PLANT_FEEDBACK_TAB, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel title={`${t('campaignRequests.title')}: ${t('plantFeedback.title')}`}>
            <DoubleTranslatedCustomRichText
              id={ID_SUMMARY_PLANT_FEEDBACK_PLANT_FEEDBACK}
              title={t('helptext')}
              initialValue={helpSummaryPlantFeedback?.SUMMARY_PLANT_FEEDBACK_PLANT_FEEDBACK}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang as 'EN' | 'DE', SUMMARY_PLANT_FEEDBACK_PLANT_FEEDBACK, newValue)}
            />
          </AccordionPanel>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  helpSummaryPlantFeedback: getHelpSummaryPlantFeedback(state),
});

const actionCreators = {
  setSummaryPlantFeedback: setHelpSummaryPlantFeedback,
};

export default connect(mapStateToProps, actionCreators)(SummaryPlantFeedbackHelpText);
